<template>
  <!-- 分类页面 -->
  <div class="page">
    <!-- 搜索栏 -->
    <div class="header-search">
      <div class="search" @click="onSearch">搜索您喜欢的物品</div>
      <div class="img-phone" @click="dialPhoneNumber()"></div>
    </div>

    <!-- 左半部 -->
    <div class="left-menu">
      <div :class="['left-menu-item', { 'item-active': isIndex == index }]" v-for="(item, index) in list" :key="index" @click="onMenu(item,index)">
        <div class="item">
          <p class="min-title van-ellipsis">{{item.type_name}}</p>
        </div>
      </div>
    </div>

    <!-- 右半部 -->
    <div class="right-menu">
      <!-- <div class="right-menu-header" v-if="imageUrl">
        <img :src="imageUrl" alt="" />
      </div> -->
      <div v-if="minList.length > 0">

        <div v-for="(it, inx) in minList" :key="inx">
          <p class="right-menu-tips">{{it.title}}</p>

          <div class="right-menu-center">

            <div class="r-item-block" v-for="(ite, inex) in it.children" :key="inex" @click="goCategoryList(ite,inex,it)">

              <van-image class="r-item-img" :src="ite.pic" alt=""></van-image>
              <p class="van-ellipsis">{{ite.title}}</p>
            </div>

          </div>
        </div>
      </div>

      <div v-else class="right-menu-loading">
        <van-divider>暂无更多</van-divider>
      </div>

      <!-- <van-button v-if="minList.length > 0" type="primary" class="foor-btn" plain block @click="goPage()">查看更多</van-button> -->
    </div>
  </div>
</template>

<script>
var isBack = true;
export default {
  beforeRouteEnter(to, from, next) {
    if (from.path == "/category-list") {
      isBack = true;
    } else {
      isBack = false;
    }
    next();
  },
  name: "Class",
  components: {},
  data() {
    return {
      isFirstEnter: false, // 是否第一次进入，默认false

      isIndex: 0,
      list: [
        // {
        //   id: 1,
        //   type_name: "食品/节日礼品",
        //   category: [
        //     {
        //       id: 13,
        //       title: "进口食品",
        //       pid: 0,
        //       cate_alias: "",
        //       pic: "/static/nopic.png",
        //       children: [
        //         {
        //           id: 15,
        //           title: "胶囊",
        //           pid: 13,
        //           cate_alias: "",
        //           pic: "/upload/20221121/625B8F625F6978293FFEA15B9BD6581B.jpg",
        //           children: [],
        //           spread: true,
        //         },
        //       ],
        //       spread: true,
        //     },
        //   ],
        // },
      ],
      minList: [
        // {
        //   id: 1,
        //   type_name: "食品/节日礼品",
        //   category: [
        //     {
        //       id: 13,
        //       title: "进口食品",
        //       pid: 0,
        //       cate_alias: "",
        //       pic: "/static/nopic.png",
        //       children: [
        //         {
        //           id: 15,
        //           title: "胶囊",
        //           pid: 13,
        //           cate_alias: "",
        //           pic: "/upload/20221121/625B8F625F6978293FFEA15B9BD6581B.jpg",
        //           children: [],
        //           spread: true,
        //         },
        //       ],
        //       spread: true,
        //     },
        //   ],
        // },
      ],
      imageUrl: "",
      typeData: {},
      category: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {
    this.isFirstEnter = true;
  },
  activated() {
    if (!isBack || this.isFirstEnter) {
      this.init();
      // console.log("刷新");
    }
    this.isFirstEnter = false;
  },
  mounted() {
    // this.init()
  },
  methods: {
    // 初始化数据
    init() {
      let _this = this;
      this.$toast.loading();
      _this.$post("/api/goods_category").then((res) => {
        console.log(res.data);
        if (res.data.code == 0 && res.data.data) {
          console.log(res.data.data);
          _this.list = res.data.data;
          _this.minList = res.data.data[0].category;

          _this.category = res.data.data[0].category;
          // _this.imageUrl = res.data.data[0].imageUrl;
          _this.$nextTick(() => {
            _this.isIndex = 0;
          });
          this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    onSearch() {
      this.$router.push({
        name: "search",
        query: {},
      });
    },
    // 左侧导航栏
    onMenu(e, index) {
      // console.log(e)
      let _this = this;
      this.$toast.loading();
      this.typeData = e;
      this.category = e.category;
      this.minList = e.category;
      this.isIndex = index;
      // this.imageUrl = e.imageUrl;
      setTimeout(function () {
        _this.$toast.clear();
      }, 100);
    },
    // 跳分类商品列表
    goCategoryList(e, index,even) {
      console.log(this.category)
      console.log(e, index,even)
      this.$router.push({
        name: "category-list",
        query: {
          typeId: this.typeData.id,
          CatalogId: e.id,
        },
      });
    },
    goPage() {
      // console.log(this.category)
      this.$router.push({
        name: "category-list",
        query: {
          id: this.typeData.id,
          CatalogId: this.category.children[0].id,
        },
      });
    },
    // 跳商品列表
    // goProductList(e,index) {
    // console.log(this.category)
    //   console.log(e, index)
    //   this.$router.push({
    //     name: "product-list",
    //     query: {
    //       id: e,
    //     },
    //   });
    // },

    // 拨打电话
    dialPhoneNumber() {
      this.MakeCall(); //拨打电话
    },
  },
};
</script>
 
<style lang="scss" scoped>
@import "@/styles/index.scss";
.page {
  height: 100%;
  min-height: 667px;
  width: 100%;
  background-color: #f9f9f9;
  // overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//  顶部
.header-search {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 44px;
  width: 100%;
  padding: 7px 15px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-shadow: 0px 2.5px 3px rgba(120, 132, 158, 0.16);
  .search {
    box-sizing: border-box;
    width: 309px;
    height: 100%;
    background-color: #e2e8ed;
    border-radius: 15px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 6px;
    color: #78849e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-phone {
    width: 20px;
    height: 20px;
    background-image: url("../../assets/home/icon7.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

// 左半部
.left-menu::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.left-menu {
  padding: 44px 0 45px;
  height: 100%;
  width: 100px;
  background-color: #eee;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  &-item {
    width: 100%;
    height: 65px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
    .item {
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .min-title {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #cccccc;
      letter-spacing: 1px;
    }
  }
  .item-active {
    background-color: #f9f9f9;
    position: relative;
    .item::after {
      content: "";
      position: absolute;
      width: 3px;
      height: 35px;
      left: 0;
      top: 15px;
      background: #ff5000;
      z-index: 1;
      border-radius: 0 10px 10px 0;
    }
    .title {
      color: #ff5000;
    }
    .min-title {
      color: #ff5000;
    }
  }
}
// 右半部
.right-menu::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.right-menu {
  width: 275px;
  height: 100%;
  min-height: 667px;
  padding: 55px 11px 45px;
  // background-color: paleturquoise;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  &-header {
    width: 100%;
    height: 100px;
    background-color: #eee;
    border-radius: 5px;
    box-shadow: 0px 3px 3px rgba(69, 79, 99, 0.06);
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }
  .right-menu-tips {
    font-size: 14px;
    color: #666;
    line-height: 30px;
    font-weight: normal;
    width: 100%;
    text-align: left;
  }
  &-center {
    margin-bottom: 15px;
    width: 100%;
    min-height: 85px;
    background-color: #fff;
    box-shadow: 0px 1px 4px rgba(69, 79, 99, 0.06);
    border-radius: 5px;
    padding-bottom: 7.5px;
    display: flex;
    flex-wrap: wrap;

    .r-item-block {
      width: 75px;
      height: 90px;
      margin: 7px 0 0 7px;
      // background-color: palegreen;
      .r-item-img {
        width: 70px;
        height: 70px;
        margin-bottom: 2px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      P {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2a2e43;
        letter-spacing: 1px;
      }
    }
  }
  &-loading {
    width: 100%;
    margin-top: 150px;
  }
  // 底部按钮
  .foor-btn {
    margin-top: 15px;
    width: 100%;
    height: 40px;
    background-color: #f9f9f9;
    color: $colorDef;
    border-color: $colorDef;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    border-radius: 5px;
  }
}
</style>
